export const baseUserNameStyle = {
  marginBlock: '0px',
  fontSize: '1em',
  cursor: 'inherit',
};
